import Service from "./Service";
const baseurl = '/api/preguntas-apgar-familiar';
export default {
    index(type) {
        return Service.get(`${baseurl}/${type}`);
    },
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    update(obj) {
        return Service.put(`${baseurl}/update`, obj);
    },
    delete(id) {
        return Service.delete(`${baseurl}/delete/${id}`);
    },
}